import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { LwButton, Page, Toolbox } from 'redesign';
import { getWorkerFullName } from 'shared/utils/worker';
import { RenderUnsettledUI } from 'shared/components';
import { useCompanyRelativePath } from 'ogp/hooks';
import { routes } from 'ogp/Routes';
import { EmployeeDetailTabs } from './employee-detail-tabs';
import { EmployeeDetailHeader } from './employee-detail-header';
import { useGetEmployeeDetail } from '../../hooks/use-get-employee-detail';

export const EmployeeDetail = () => {
  const { id } = useParams<'id'>();
  const employeeQuery = useGetEmployeeDetail(id ?? '');
  const generatePath = useCompanyRelativePath();

  if (employeeQuery.status !== 'success') {
    return <RenderUnsettledUI data={employeeQuery} />;
  }

  return (
    <Page
      header={<EmployeeDetailHeader name={getWorkerFullName(employeeQuery.data)} />}
      toolbox={
        <Toolbox>
          <LwButton to={generatePath(routes.Workforce)} type="submit">
            Terug
          </LwButton>
        </Toolbox>
      }
    >
      <Box width="100%">
        <EmployeeDetailTabs data={employeeQuery.data} />
      </Box>
    </Page>
  );
};
